var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredAchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11931_17019)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38Z",
    fill: "#DFE2EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11931_17019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6381 27.3601C29.6381 26.1009 28.6173 25.0801 27.3581 25.0801C26.0989 25.0801 25.0781 26.1009 25.0781 27.3601V44.8401C25.0781 46.0993 26.0989 47.1201 27.3581 47.1201C28.6173 47.1201 29.6381 46.0993 29.6381 44.8401V27.3601Z",
    fill: "white",
    stroke: "#00193C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2787 27.3601C40.2787 26.1009 39.258 25.0801 37.9987 25.0801C36.7395 25.0801 35.7188 26.1009 35.7188 27.3601V44.8401C35.7188 46.0993 36.7395 47.1201 37.9987 47.1201C39.258 47.1201 40.2787 46.0993 40.2787 44.8401V27.3601Z",
    fill: "white",
    stroke: "#00193C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6811 27.3601C51.6811 26.1009 50.6603 25.0801 49.4011 25.0801C48.1419 25.0801 47.1211 26.1009 47.1211 27.3601V44.8401C47.1211 46.0993 48.1419 47.1201 49.4011 47.1201C50.6603 47.1201 51.6811 46.0993 51.6811 44.8401V27.3601Z",
    fill: "white",
    stroke: "#00193C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8008 45.8398C22.8008 45.2876 23.2485 44.8398 23.8008 44.8398H52.9608C53.5131 44.8398 53.9608 45.2876 53.9608 45.8398V47.6398C53.9608 48.1921 53.5131 48.6398 52.9608 48.6398H23.8008C23.2485 48.6398 22.8008 48.1921 22.8008 47.6398V45.8398Z",
    fill: "white",
    stroke: "#00193C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2812 49.6396C21.2812 49.0874 21.729 48.6396 22.2812 48.6396H51.4412C51.9935 48.6396 52.4412 49.0874 52.4412 49.6396V52.1996C52.4412 52.7519 51.9935 53.1996 51.4412 53.1996H22.2813C21.729 53.1996 21.2812 52.7519 21.2812 52.1996V49.6396Z",
    fill: "white",
    stroke: "#00193C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0391 27.3595C22.4868 27.3595 22.0391 26.9118 22.0391 26.3595V25.2969C22.0391 24.9032 22.2701 24.5461 22.6292 24.3848L37.5892 17.6636C37.8499 17.5465 38.1482 17.5465 38.4089 17.6636L53.3689 24.3848C53.728 24.5461 53.9591 24.9032 53.9591 25.2969V26.3595C53.9591 26.9118 53.5113 27.3595 52.9591 27.3595H23.0391Z",
    fill: "white",
    stroke: "#00193C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3905 20.6698C37.6531 20.4073 38.0092 20.2598 38.3805 20.2598C38.7518 20.2598 39.1079 20.4073 39.3704 20.6698C39.633 20.9324 39.7805 21.2885 39.7805 21.6598C39.7805 22.0311 39.633 22.3872 39.3704 22.6497C39.1079 22.9123 38.7518 23.0598 38.3805 23.0598C38.0092 23.0598 37.6531 22.9123 37.3905 22.6497C37.128 22.3872 36.9805 22.0311 36.9805 21.6598C36.9805 21.2885 37.128 20.9324 37.3905 20.6698Z",
    fill: "#0E5CF4",
    stroke: "#20242E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.6383,
    cy: 46.36,
    r: 10.9,
    fill: "#0E5CF4",
    stroke: "#20242E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0645 44.4858V41.7913C48.0645 41.6427 48.0217 41.4974 47.9416 41.3739C47.8614 41.2504 47.7475 41.1541 47.6142 41.0972C47.4809 41.0404 47.3343 41.0255 47.1928 41.0545C47.0513 41.0834 46.9213 41.155 46.8193 41.26L42.015 46.2088C41.8782 46.3497 41.8014 46.5408 41.8014 46.74C41.8014 46.9393 41.8782 47.1304 42.015 47.2713L46.8193 52.22C46.9213 52.3251 47.0513 52.3966 47.1928 52.4256C47.3343 52.4546 47.4809 52.4397 47.6142 52.3829C47.7475 52.326 47.8614 52.2297 47.9416 52.1062C48.0217 51.9826 48.0645 51.8374 48.0645 51.6888V48.9943H52.4414V44.4858H48.0645Z",
    fill: "#F6F7FA",
    stroke: "#00193C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9609 44.46H55.4809V49.02H53.9609V44.46Z",
    fill: "#F6F7FA",
    stroke: "#00193C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11931_17019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11931_17019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.52,
    height: 41.04,
    fill: "white",
    transform: "translate(20.5195 16.7197)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredAchIcon);
export default __webpack_public_path__ + "static/media/ic-colored-ach-icon.93014ba153d12200b98093c5743a9cf0.svg";
export { ForwardRef as ReactComponent };